/**
 * 标签定义表（纯数据，不掺玩法规矩）。
 *
 * 每个标签只有三件事：
 *   name  — 显示在人物状态里的名字
 *   decay — 每天自然消退多少点（0 = 不退）
 *   cap   — 上限
 * 其余的「怎么给、到多少数、别人怎么 reaction」都在各系统里，改这里不影响玩法。
 */
export const TAG_DEFS = {
  dirty: { name: '一身灰', decay: 0.25, cap: 90 },
  stink: { name: '馊水味', decay: 0.25, cap: 70 },
  friendOfStray: { name: '野狗朋友', decay: 0.10, cap: 80 },
  streetKid: { name: '街溜子', decay: 0.15, cap: 80 },
  noisyNight: { name: '夜夜笙歌', decay: 0.50, cap: 60 },
  noLicense: { name: '无照经营', decay: 0.02, cap: 100 },
  face: { name: '脸面', decay: 0.10, cap: 90 },
  trustOfLocals: { name: '邻里信任', decay: 0.10, cap: 100 },
  wellSpoken: { name: '谈吐得体', decay: 0.10, cap: 90 },
  honest: { name: '诚实之价', decay: 0.05, cap: 120 },
  industrious: { name: '踏实之价', decay: 0.05, cap: 120 },
  skillful: { name: '手巧之名', decay: 0.02, cap: 120 },
  learned: { name: '有见识', decay: 0.05, cap: 120 },

  /* 谋生的本事：打工、跑腿、出货攒出来的 */
  labor: { name: '卖力气', decay: 0.05, cap: 120 },
  hauling: { name: '搬货', decay: 0.05, cap: 120 },
  errands: { name: '跑腿', decay: 0.08, cap: 120 },
  aid: { name: '当差', decay: 0.05, cap: 120 },
  machinery: { name: '摆弄机器', decay: 0.02, cap: 120 },
  restaurant: { name: '做吃的', decay: 0.05, cap: 120 },
  trading: { name: '做买卖', decay: 0.05, cap: 120 },

  /* 地里与静心：种一季菜、坐一阵蒲团攒出来的 */
  farming: { name: '侍弄庄稼', decay: 0.06, cap: 120 },
  insight: { name: '静心', decay: 0.08, cap: 120 },
};

/** 资格证 / 身份标签：只能通过特定途径获得，有就是有，没有就是没有 */
export const CERT_DEFS = {
  studentId: { name: '学子牌', decay: 0, cap: 120 },
  landDeed: { name: '地契', decay: 0, cap: 120 },
  residencePermit: { name: '居留', decay: 0, cap: 120 },
  transportLicense: { name: '行商牌', decay: 0, cap: 120 },
  workshopLicense: { name: '作场准许', decay: 0, cap: 120 },
  foodHygiene: { name: '食肆整洁', decay: 0, cap: 120 },
  entertainmentGuard: { name: '瓦舍守序', decay: 0, cap: 120 },
  petRegistration: { name: '牲口牌', decay: 0, cap: 120 },
  businessTaxClear: { name: '完税', decay: 0, cap: 120 },
  saltPermit: { name: '盐引', decay: 0, cap: 120 },
  liquorPermit: { name: '酒引', decay: 0, cap: 120 },
  nightPass: { name: '夜行牌', decay: 0, cap: 120 },
  citizenRights: { name: '市民权', decay: 0, cap: 120 },
  carPlate: { name: '车牌', decay: 0, cap: 120 },

  /* ---- 手艺资格证：不是衙署发的，是灵感撞出来的（见 data/inspire.js 的门路） ---- */
  cook_1: { name: '火房帮工', decay: 0, cap: 120 },
  cook_2: { name: '灶上伙计', decay: 0, cap: 120 },
  cook_3: { name: '掌勺的', decay: 0, cap: 120 },
  cook_4: { name: '灶头师傅', decay: 0, cap: 120 },
  farm_1: { name: '会伺弄', decay: 0, cap: 120 },
  farm_2: { name: '地里熟手', decay: 0, cap: 120 },
  farm_3: { name: '老把式', decay: 0, cap: 120 },
  farm_4: { name: '一方的农把式', decay: 0, cap: 120 },
  trade_1: { name: '跑腿的', decay: 0, cap: 120 },
  trade_2: { name: '贩子', decay: 0, cap: 120 },
  trade_3: { name: '行商', decay: 0, cap: 120 },
  trade_4: { name: '老客商', decay: 0, cap: 120 },
  craft_1: { name: '上手', decay: 0, cap: 120 },
  craft_2: { name: '帮工', decay: 0, cap: 120 },
  craft_3: { name: '作头', decay: 0, cap: 120 },
  craft_4: { name: '老师傅', decay: 0, cap: 120 },
  scholar_1: { name: '识字的', decay: 0, cap: 120 },
  scholar_2: { name: '能写会算', decay: 0, cap: 120 },
  scholar_3: { name: '明理的', decay: 0, cap: 120 },
  scholar_4: { name: '先生', decay: 0, cap: 120 },
};

/** 一条标签要给人看见，总得过这个数（不到就不值一提） */
export const TAG_SHOW_MIN = 10;

/** 数值转第几层：这个标签看着有多扎眼，1~5 */
export function tagStage(value) {
  if (value >= 120) return 5;
  if (value >= 90) return 4;
  if (value >= 60) return 3;
  if (value >= 30) return 2;
  return 1;
}

export function tagName(id) {
  return (TAG_DEFS[id] || CERT_DEFS[id] || {}).name || id;
}

export function tagCap(id) {
  return (TAG_DEFS[id] || CERT_DEFS[id] || {}).cap || 100;
}

export function tagDecay(id) {
  return (TAG_DEFS[id] || CERT_DEFS[id] || {}).decay || 0;
}

export function isCert(id) {
  return !!CERT_DEFS[id];
}
